export const DSName = '仙台北自動車学校'
export const StudentDisplay = '教習生'
export const ReserveScreenMessage = ''

// 予約ページ
export const FewSlotsThreshold = 1
export const RegularSlotsThreshold = 1
export const ManySlotsThreshold = 999

// マイページ
export const DisplayFinancialRecord = 0

// 指導員ページ
export const DisplayInstructorPictures = 0
export const CanChangeInstructorPreference = 1
export const DisplayYusenInstructors = 0

// バス予約ページ
export const DisplayBusReservation = 1

// メンテナンスﾌﾗｸﾞ
export const UnderMaintenance = 0


